__turbopack_context__.v({
  "bottom": "OptionChainMiddle-module-scss-module__CwaVaW__bottom",
  "middle": "OptionChainMiddle-module-scss-module__CwaVaW__middle",
  "middleComponentContainerDesktop": "OptionChainMiddle-module-scss-module__CwaVaW__middleComponentContainerDesktop",
  "middleComponentContainerMobile": "OptionChainMiddle-module-scss-module__CwaVaW__middleComponentContainerMobile",
  "top": "OptionChainMiddle-module-scss-module__CwaVaW__top",
});
